// extracted by mini-css-extract-plugin
module.exports = {"formInsurance":"InsuranceForm_formInsurance__3A3L1","btnWrapper":"InsuranceForm_btnWrapper__Ed-JR"};